export { getPathname, usePathname } from "@/i18n/navigation-base"
export { Link, useRouter } from "@/i18n/NavigationClient"
